"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubDejaSouscritCombienCorporationTrads = void 0;
exports.ESubDejaSouscritCombienCorporationTrads = {
    less_than_3: "Moins de 3",
    more_than_3: "Plus de 3",
};
